<mat-dialog-content>
    <div class="avenue-asset-dialog__header">
        <div class="spacer"></div>
        <h3>
            <span class="main-header">
                <mat-icon svgIcon="perform" class="panel-header-icon"></mat-icon
                >{{ (performAsset) ? "Edit" : "Create"
                }}<span>&nbsp;Media</span>
            </span>
        </h3>
        <!-- Cancel button -->
        <button
            (click)="this.dialogRef.close()"
            mat-icon-button
            aria-label="Close Create Media Dialog"
            type="button"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-divider></mat-divider>

    <avenue-asset-form
        [performAsset]="performAsset"
        [userGUID]="userGUID$ | async"
        [subjectId]="subjectId"
        [assetAssociation]="assetAssociation"
        (create)="onCreate($event)"
        (update)="onUpdate($event)"
        (cancel)="onCancel()"
    >
    </avenue-asset-form>
</mat-dialog-content>
